var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 7C12.9375 8.50842 12.3383 9.95506 11.2717 11.0217C10.2051 12.0883 8.75842 12.6875 7.25 12.6875C5.74158 12.6875 4.29494 12.0883 3.22833 11.0217C2.16172 9.95506 1.5625 8.50842 1.5625 7C1.5625 5.49158 2.16172 4.04494 3.22833 2.97833C4.29494 1.91172 5.74158 1.3125 7.25 1.3125C8.75842 1.3125 10.2051 1.91172 11.2717 2.97833C12.3383 4.04494 12.9375 5.49158 12.9375 7ZM0.25 7C0.25 8.85652 0.987498 10.637 2.30025 11.9497C3.61301 13.2625 5.39348 14 7.25 14C9.10652 14 10.887 13.2625 12.1997 11.9497C13.5125 10.637 14.25 8.85652 14.25 7C14.25 5.14348 13.5125 3.36301 12.1997 2.05025C10.887 0.737498 9.10652 0 7.25 0C5.39348 0 3.61301 0.737498 2.30025 2.05025C0.987498 3.36301 0.25 5.14348 0.25 7ZM6.59375 3.28125V7C6.59375 7.21875 6.70312 7.42383 6.88633 7.54688L9.51133 9.29688C9.81211 9.49922 10.2195 9.41719 10.4219 9.11367C10.6242 8.81016 10.5422 8.40547 10.2387 8.20312L7.90625 6.65V3.28125C7.90625 2.91758 7.61367 2.625 7.25 2.625C6.88633 2.625 6.59375 2.91758 6.59375 3.28125Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmWatch);
export default __webpack_public_path__ + "static/media/sm-watch.c3db2bcd92df79ae5fd30aeccbaecfd4.svg";
export { ForwardRef as ReactComponent };